export enum ClusterMappingType {
  None = 'None',
  Geo = 'Geo',
  Org = 'Org'
}
